/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SideBarMenuItemModel} from './side-bar-menu-item.model';
import {Router} from '@angular/router';
import {AbstractSideBarMenuComponent} from '../abstract-side-bar-menu-component';
import {SpoSearchCriteriaService} from '../../../spo/services/spo-search-criteria.service';
import {ClaimSearchCriteriaService} from '../../../claim/services/claim-search-criteria.service';
import {PartNumberChangesSearchCriteriaService} from '../../../part-number-changes/services/part-number-changes-search-criteria.service';
import {SettlementSearchCriteriaService} from '../../../settlements/services/settlement-search-criteria.service';

@Component({
    selector: 'app-side-bar-menu-item',
    templateUrl: './side-bar-menu-item.component.html',
    styleUrls: ['./side-bar-menu-item.component.css', '../side-bar-menu-item.shared.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SideBarMenuItemComponent extends AbstractSideBarMenuComponent implements OnInit {
    @Input() menuItems: SideBarMenuItemModel[] = [];
    @Input() depth = 0;

    constructor(private router: Router,
                spoSearchCriteriaService: SpoSearchCriteriaService,
                claimSearchCriteriaService: ClaimSearchCriteriaService,
                partNumberChangesCriteriaService: PartNumberChangesSearchCriteriaService,
                settlementSearchCriteriaService: SettlementSearchCriteriaService) {
        super(spoSearchCriteriaService, claimSearchCriteriaService, partNumberChangesCriteriaService, settlementSearchCriteriaService);
    }

    ngOnInit(): void {
    }

    isRouteActive(menuItem: SideBarMenuItemModel): boolean {
        return this.router.isActive(menuItem.url, false);
    }

    toggleExpanded(menuItem: SideBarMenuItemModel, event: Event): void {
        event.stopPropagation();
        menuItem.isExpanded = !menuItem.isExpanded;
    }

    getExpandedIcon(menuItem: SideBarMenuItemModel): string {
        return menuItem.isExpanded ? 'iwp-icon-gen_nav_arrow_up' : 'iwp-icon-gen_nav_arrow_down';
    }
}
